var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMeydanIstanbul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.172,
    height: 35.414,
    viewBox: "0 0 86.172 35.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M32.254,83.406h5.585l3.427,5.628L44.7,83.406h5.581V99.42H44.955V91.486l-3.689,5.691h-.087l-3.688-5.691V99.42H32.254Z",
    transform: "translate(-32.254 -82.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M78.464,98.208v-.044a6.316,6.316,0,0,1,6.431-6.57c4.461,0,6.5,3.091,6.5,6.886,0,.274,0,.6-.02.875H83.34a2.332,2.332,0,0,0,2.354,1.666,3.478,3.478,0,0,0,2.542-1.283l2.791,2.217a6.694,6.694,0,0,1-5.7,2.723c-4.121,0-6.867-2.581-6.867-6.471m8.192-1.144c-.115-1.192-.823-1.875-1.742-1.875-.89,0-1.488.707-1.646,1.875Z",
    transform: "translate(-60.277 -87.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M107.046,107.274l1.512-3.546a5.7,5.7,0,0,0,2.284.819,1.973,1.973,0,0,0,.845-.182l-4.894-12.008h5.378l2.173,6.586,1.987-6.586h5.287l-4.321,11.62c-1.211,3.274-2.542,4.6-5.422,4.6a9.568,9.568,0,0,1-4.829-1.3",
    transform: "translate(-77.456 -87.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M140.611,91.435v-.047c0-4.235,2.569-7.048,5.7-7.048a4.987,4.987,0,0,1,4.014,1.835V80.158h5.552V98.017h-5.552V96.378a4.974,4.974,0,0,1-3.966,1.955c-3.226,0-5.748-2.81-5.748-6.9m9.836-.075v-.043a2.289,2.289,0,0,0-2.224-2.4,2.262,2.262,0,0,0-2.229,2.4v.043a2.233,2.233,0,1,0,4.453,0",
    transform: "translate(-97.965 -80.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M179.22,100.824v-.048c0-2.667,1.954-4.16,5.086-4.16a9.605,9.605,0,0,1,3.159.491v-.222c0-1.251-.737-1.936-2.474-1.936a9.777,9.777,0,0,0-3.7.76l-.972-3.693a15.23,15.23,0,0,1,5.628-.978c2.738,0,4.476.562,5.648,1.734A5.473,5.473,0,0,1,192.989,97v7.612h-5.553V103.27a5.073,5.073,0,0,1-3.838,1.662c-2.569,0-4.378-1.468-4.378-4.108m8.291-1.152v-.562a3.922,3.922,0,0,0-1.274-.218,1.507,1.507,0,0,0-1.71,1.488v.051a1.24,1.24,0,0,0,1.27,1.3c.983,0,1.714-.788,1.714-2.058",
    transform: "translate(-121.379 -86.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M215.079,91.1h5.553v1.856a5.222,5.222,0,0,1,4.084-2.176c2.838,0,4.58,1.836,4.58,4.872v8.806h-5.558V97.44c0-1.155-.656-1.817-1.515-1.817a1.64,1.64,0,0,0-1.592,1.817v7.018h-5.553Z",
    transform: "translate(-143.125 -86.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(0 22.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M32.254,138.361h1.054v1.166H32.254Zm.105,3.469H33.2v8.85h-.844Z",
    transform: "translate(-32.254 -138.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M41.682,148.909l.59-.679a5.833,5.833,0,0,0,4.356,1.811c1.821,0,3.071-1.029,3.071-2.421v-.028c0-1.282-.677-2.031-3.439-2.587-2.926-.606-4.088-1.56-4.088-3.42v-.032c0-1.8,1.648-3.193,3.9-3.193a6.089,6.089,0,0,1,4.166,1.475l-.573.71a5.27,5.27,0,0,0-3.623-1.371c-1.809,0-2.971,1.046-2.971,2.294v.034c0,1.3.66,2.043,3.539,2.654,2.825.572,3.992,1.563,3.992,3.346v.033c0,1.96-1.685,3.314-4.029,3.314a6.927,6.927,0,0,1-4.89-1.941",
    transform: "translate(-37.971 -138.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M73.25,139.637H69.017V138.8h9.364v.832H74.153v11.312h-.9Z",
    transform: "translate(-54.548 -138.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M98.821,138.584h.869l5.65,12.231h-.982l-1.55-3.4H95.644l-1.542,3.4h-.94Zm3.605,8.015-3.188-7.025-3.21,7.025Z",
    transform: "translate(-69.191 -138.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M130.634,138.8h.852l8.379,10.564V138.8h.869v12.144h-.677L131.5,140.159v10.789h-.869Z",
    transform: "translate(-91.915 -138.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M165.459,138.8h5.016a4.361,4.361,0,0,1,3.154,1.078,2.587,2.587,0,0,1,.781,1.906v.034a3,3,0,0,1-2.06,2.879c1.455.383,2.741,1.232,2.741,2.9v.03c0,2.033-1.738,3.316-4.359,3.316h-5.273Zm4.911,5.6c1.8,0,3.126-.886,3.126-2.5v-.035c0-1.337-1.083-2.239-3.038-2.239h-4.1v4.772Zm.4,5.7c2.082,0,3.4-.952,3.4-2.481v-.03c0-1.513-1.287-2.362-3.7-2.362h-4.113v4.873Z",
    transform: "translate(-113.034 -138.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M196.806,145.9v-7.1h.9v7.008c0,2.9,1.525,4.51,4.112,4.51,2.446,0,4.041-1.494,4.041-4.422v-7.1h.9V145.8c0,3.469-2.027,5.341-4.977,5.341-2.913,0-4.977-1.839-4.977-5.236",
    transform: "translate(-132.044 -138.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M230.8,138.8h.9v11.308h7.13v.836H230.8Z",
    transform: "translate(-152.657 -138.63)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMeydanIstanbul);
export default __webpack_public_path__ + "static/media/logo-meydan-istanbul.e8f64668d39fff59394c6d1c92e20a6f.svg";
export { ForwardRef as ReactComponent };